import "../css/style.scss"

// Our modules / classes
import MobileMenu from "./modules/MobileMenu"
import HeroSlider from "./modules/HeroSlider"
import OverlaySearch from './modules/OverlaySearch';
import StickyHeader from "./modules/StickyHeader";
import MyNotes from "./modules/MyNotes";
import Like from "./modules/Like";

import "../../../mu-plugins/rudra-custom-component/src/CustomLog"

import V1TutorialTemplete from "./modules/V1TutorialTemplete";
import V2TutorialTemplete from "./modules/V2TutorialTemplete";
import ThemeSwitcher from "./../../../plugins/rudra-shader-editor-block/src/js/ThemeSwitcher";

// Instantiate a new object using our modules/classes
const themeSwitcher = ThemeSwitcher.GetInstance(); 

const mobileMenu = new MobileMenu();
const heroSlider = new HeroSlider();
const overlaySearch = new OverlaySearch();
const stickyHeader = new StickyHeader();
const myNotes = new MyNotes();
const like = new Like();

const tutorialScript = new V1TutorialTemplete();
const tutorialTemplete = new V2TutorialTemplete();


 